"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vanilla_jsoneditor_1 = require("vanilla-jsoneditor");
var lossless_json_1 = require("lossless-json");
var LosslessJSONParser = { parse: lossless_json_1.parse, stringify: lossless_json_1.stringify };
function isJsonString(str) {
    if (typeof str !== "string")
        return false; // early return if undefined
    try {
        (0, lossless_json_1.parse)(str);
    }
    catch (e) {
        return false;
    }
    return true;
}
// Initialize all JSON editors
function jsoneditor() {
    var jsonEditors = document.querySelectorAll(".jsoneditor");
    if (jsonEditors.length > 0) {
        window.NewJSONEditor = vanilla_jsoneditor_1.JSONEditor;
        jsonEditors.forEach(function (element) {
            var _a;
            var editMode = (_a = element.dataset.mode) !== null && _a !== void 0 ? _a : "edit";
            var initialJson = { json: (0, lossless_json_1.parse)(element.dataset.json || '') };
            var editor = new vanilla_jsoneditor_1.JSONEditor({
                target: element,
                props: {
                    onChange: function (updatedContent, _previousContent, _a) {
                        var patchResult = _a.patchResult;
                        var emitTo = element.dataset.emit_to;
                        if (!emitTo)
                            return;
                        var payload = null;
                        if (!patchResult && isJsonString(updatedContent.text)) {
                            payload = (0, lossless_json_1.parse)(updatedContent.text);
                        }
                        else if (patchResult &&
                            isJsonString((0, lossless_json_1.stringify)(patchResult.json))) {
                            payload = patchResult.json;
                        }
                        if (payload !== null) {
                            window.livewire.emit(emitTo, (0, lossless_json_1.stringify)(payload), element.dataset.key, element.dataset.column, element.dataset.rowid);
                        }
                    },
                    sortObjectKeys: true,
                    readOnly: editMode === "view",
                    navigationBar: editMode !== "view",
                    mainMenuBar: editMode !== "view",
                    mode: vanilla_jsoneditor_1.Mode.tree,
                    parser: LosslessJSONParser,
                    queryLanguages: [vanilla_jsoneditor_1.lodashQueryLanguage, vanilla_jsoneditor_1.jmespathQueryLanguage],
                    onRenderMenu: function (items) {
                        return items.filter(function (v) { return v.text !== "table" && v.type === "button"; });
                    },
                },
            });
            editor.set(initialJson);
        });
    }
}
exports.default = jsoneditor;
